<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
        <div class="currentYear" v-if="$attrs.showYear">{{new Date().getFullYear()}}年</div>

    </div>
</template>

<script>
    import echarts from 'echarts';

    export default {
        name: 'lineCharts',
        props: {
            'data': Array,
            'dataTitle': Array,
            'color': String, // 如果是green则绿色模式，否则是白色模式
            'unit': String // 单位
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                unitName: '条'
            };
        },
        mounted () {
            this.unitName = this.unit ? this.unit : '条';
            this.option = {
                color:['#FF8C19','#36B374'],
                // color:['#2db7f5','#ff6600'],
                legend: {
                    data: ['2020年','2021年'],
                    // orient: 'vertical',
                    x:'right',      //可设定图例在左、右、居中
                    y:'10',     //可设定图例在上、下、居中
                    color:['#eee','#666']
                },
                xAxis: {
                    splitNumber: 100
                },
                dataZoom: [
                    {
                        type: 'inside',
                        start: 0,
                        end: 60,
                        zoomLock:true
                    }
                ],
                tooltip: {
                    trigger: 'axis',
                    triggerOn: 'click'
                    // formatter (params) {
                    //     let time = new Date().getFullYear();
                    //     let text = `${time}年${params[0].name}日 <br /> 申请数量 ${params[0].data} 起<br />${time - 1}年${params[1].name}日 <br /> 申请数量 ${params[1].data} 起`;
                    //     return text;
                    // }
                },
                grid: {
                    top: 70,
                    right: 24,
                    left: 41
                },

                yAxis: {
                    name: ` 单位 (${this.unitName})`,
                    nameGap: '16',
                    splitNumber: 3,
                    nameTextStyle: {
                        color: '#999'
                    },
                    type: 'value',
                    'axisLine': { // y轴
                        'show': false
                    },
                    // 网格样式
                    'splitLine': {
                        show: true,
                        lineStyle: {
                            color: this.color === 'green' ? '#E9E9E9' : '#ffffff',
                            width: 0.5,
                            type: 'solid'
                        }
                    },
                    // interval: 5,
                    'axisTick': { // y轴刻度线
                        'show': false
                    },
                    'axisLabel': {
                        show: true,
                        textStyle: {
                            // color: this.color === 'green' ? 'rgba(0,0,0,.45)' : '#ffffff'
                        }
                    }
                },
                lineStyle: {
                    // color: this.color === 'green' ? 'rgba(54,179,116,0)' : 'rgba(255,255,255,1)',
                    // width: 1
                },
                itemStyle: {
                    // color: this.color === 'green' ? 'rgba(54,179,116,1)' : 'rgba(255,255,255,1)',
                    // opacity: 1
                },
                series: []
            }
            this.echartObj = echarts.init(document.getElementById(this.id));
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        watch: {
            data: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            // 尝试返回数据后刷新试图
            freshCharts () {
                this.echartObj.setOption(this.setSeriesData(), true);
            },
            getXaxisData () {
                // 填入横轴数据
                if (this.data.length > 0) {
                    return this.dataTitle.map(item => {
                        return item.toString().replace('-', '月')
                    });
                }
            },
            getSeriesData () {
                // 填入数据
                if (this.data.length > 0) {
                    return this.data.map(item => {
                        return item.data
                    });
                }
            },
            setSeriesData () {
                this.setOptions('xAxis', (() => {
                    return {
                        type: 'category',
                        boundaryGap: false,
                        splitNumber: 1000,
                        minInterval: 100,
                        data: this.getXaxisData(),
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: this.color === 'green' ? '#E9E9E9' : '#ffffff'
                            }
                        },
                        axisTick: { // y轴刻度线
                            show: false
                        },
                        axisLabel: {
                            interval: 4,
                            show: true,
                            textStyle: {
                                color: this.color === 'green' ? '#999999' : '#ffffff'
                            }
                        }
                    }
                })());
                this.setOptions('series', (() => {
                    return [
                        {
                            name: '2020年',
                            data: this.data ? this.data[0].data : [],
                            type: 'line',
    
                            lineStyle: {
                                width: 1,
                                 color: '#FF8C19'// hover拐点颜色定义
                            },
                            // smooth:true,
                            smooth: false,
                            // symbol: 'circle', // 拐点设置为实心
                            symbolSize: 6, // 拐点大小
                            areaStyle: {
                                normal: {
                                    color:'#fff',
                                    
                                    // normal : {color : '#ffffff'}//改变区域颜色
                                    // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    //     { offset: 0, color: this.color === 'green' ? 'rgba(54,179,116,1)' : 'rgba(255,255,255,1)' },
                                    //     { offset: 1, color: this.color === 'green' ? 'rgba(54,179,116,0)' : 'rgba(255,255,255,0)' }
                                    // ])
                                }
                            },
                            itemStyle: {
                                normal: {
                                    color: '#FF8C19', // 拐点颜色
                                    borderColor: '#FF8C19', // 拐点边框颜
                                    borderWidth: 1, // 拐点边框大小
                                    label: {
                                        show: true,
                                        color: this.color === 'green' ? 'rgba(255,140,25,0)' : 'rgba(255,255,255,1)',
                                        formatter: function (param) {
                                            return param.value == '0' ? '' : param.value;
                                        }
    
                                    }
                                },
                                emphasis: {
                                    color: '#FF8C19'// hover拐点颜色定义
                                }
                            }
    
                        },
                        {
                            name: '2021年',
                            data: this.data ? this.data[1].data : [],
                            type: 'line',
    
                            lineStyle: {
                                width: 1,
                                 color: '#36B374'
                               
                            },
                            // smooth:true,
                            // smooth: true,
                            // symbol: 'circle', // 拐点设置为实心
                            symbolSize: 6, // 拐点大小
                            areaStyle: {
                                normal: {
                                    color:'#fff',
                                    // color : '#ffffff'//改变区域颜色
                                    // color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    //     { offset: 0, color: this.color === 'green' ? 'rgba(255,255,255,1)' : 'rgba(54,179,116,1)' },
                                    //     { offset: 1, color: this.color === 'green' ? 'rgba(255,255,255,0)' : 'rgba(54,179,116,0)' }
                                    // ])
                                }
                            },
                            itemStyle: {
                                normal: {
                                    
                                    color: '#36B374', // 拐点颜色
                                    borderColor: 'rgba(54,179,116,1)', // 拐点边框颜色
                                    borderWidth: 1, // 拐点边框大小
                                    // opacity:0,
                                    label: {
                                        show: true,
                                        color: this.color === 'green' ? 'rgba(54,179,116,0)' : 'rgba(255,255,255,1)',  // 折线上点的数据
                                        formatter: function (param) {
                                            return param.value == '0' ? '' : param.value;
                                        }
    
                                    }
                                },
                                emphasis: {
                                    color:'rgba(54,179,116,1)'
                                }
                            }
    
                        }
                    ]
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    position: relative;
    .o-echarts {
        width: 100%;
        height: 99%;
        padding-bottom: 10px;

    }
    .currentYear{
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 0;
        padding-bottom: 16px;
        color: #999999;
        font-size: 12px;

    }
}
</style>
